import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

//import GenericFilter from "./GenericFilter";
import Institution from "./Institution";
import clientComponent from "../config/clientComponents";

import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

const FilterSection = ({
  data,
  filteredEntities,
  setFilteredEntities,
  selectedInstitution,
  setSelectedInstitution,
  filtersState,
  setFiltersState,
  filtersKeys,
  searchState,
  setSearchState,
  filterScreen,
  setFilterScreen,
  mapScreen,
  setMapScreen,
  setScrollbarRef,
  lineRefs,
  showFiltersFrom,
  setShowFiltersFrom,
}) => {
  const { t, i18n } = useTranslation();
  const [isInData, setIsInData] = useState(false);
  const inputSearchRef = useRef(null);
  //--- Set the state that is used to know if the selected institution is in the net set of institutions
  //--- (after a filter input for example)
  //--- that was used before we decided to reset selectedInstitution on any filter/search input
  useEffect(() => {
    if (selectedInstitution) {
      for (const entity of filteredEntities) {
        if (entity.id === selectedInstitution.id) {
          setIsInData(true);
          return null;
        }
      }
      setIsInData(false);
    } else {
      setIsInData(false);
    }
  }, [data]);

  //--- Reset the selected institution if not in new set of institutions
  useEffect(() => {
    if (!isInData) {
      setSelectedInstitution();
    }
  }, [isInData]);

  //--- Show filter screen on mobile
  const handleFilterScreen = () => {
    document.body.classList.add("no-scroll");
    setFilterScreen(true);
    setShowFiltersFrom("from-list");
  };

  //--- Hide filter screen on mobile
  const closeFilterScreen = () => {
    if (mapScreen && filterScreen) {
      setFilterScreen(false);
    } else {
      document.body.classList.remove("no-scroll");
      setFilterScreen(false);
    }
  };

  //--- Hide filter screen and show map screen on mobile
  const handleMapScreen = () => {
    document.body.classList.add("no-scroll");
    setFilterScreen(false);
    setMapScreen(true);
  };

  const resetFilters = () => {
    for (const filterKey of filtersKeys) {
      setFiltersState((prevState) => ({
        ...prevState,
        [filterKey]: [],
      }));
    }
  };

  let typingTimer; //timer identifier
  const doneTypingInterval = 500; //time in ms, 5 second for example
  const handleType = (value) => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      setSearchState(value);
    }, doneTypingInterval);
  };

  const emptySearchbar = () => {
    inputSearchRef.current.value = "";
    setSearchState("");
  };

  //count active filters
  let activeFilterCount = 0;
  filtersKeys.forEach((key) => {
    if (filtersState[key]?.length) {
      activeFilterCount += filtersState[key]?.length;
    }
  });

  //--- Dynamic import
  const GenericFilter = clientComponent["GenericFilter"];

  const filterList = filtersKeys.map((filter, index) => {
    return (
      <GenericFilter
        key={filter}
        filters={data.filters}
        filterName={filter}
        filtersState={filtersState}
        setFiltersState={setFiltersState}
        client={process.env.REACT_APP_CLIENT}
        setSelectedInstitution={setSelectedInstitution}
        index={index}
        filtersKeys={filtersKeys}
      />
    );
  });

  return (
    <>
      <div className="sidebar__title-wrapper">
        <h2 className="sidebar__title has-primary-background-color has-white-color">
          {data.filterSectionTitle}
        </h2>
        <button
          className={`sidebar__btn-filtres ${
            process.env.REACT_APP_FILTERS === "modal" ? "show" : ""
          }`}
          onClick={handleFilterScreen}
        >
          <span className="icon iconReactLeafletfilter"></span>
          {t("filters")}
          {activeFilterCount !== 0 && (
            <span className="count">{activeFilterCount}</span>
          )}
        </button>
      </div>
      {process.env.REACT_APP_SEARCHBAR !== "false" && (
        <div className="search-input__wrapper">
          <span className="iconReactLeafletsearch"></span>
          <input
            placeholder={`${t("search")}...`}
            className="search-input"
            type={"text"}
            onChange={(e) => {
              handleType(e.target.value);
            }}
            ref={inputSearchRef}
          ></input>
          {searchState && (
            <span
              onClick={emptySearchbar}
              className="icon iconReactLeafletx"
            ></span>
          )}
        </div>
      )}
      <div
        className={`sidebar-filter__wrapper ${
          filterScreen === true ? "active" : ""
        } ${
          process.env.REACT_APP_FILTERS === "modal"
            ? "sidebar-filter__wrapper--modal"
            : ""
        }`}
      >
        <div className="sidebar-filter__wrapper--title">
          <h3 className="sidebar__title">{t("filters")}</h3>
          <span
            className="sidebar-filter__wrapper--button"
            onClick={closeFilterScreen}
          >
            <svg
              version="1.1"
              id="Calque_1"
              x="0px"
              y="0px"
              viewBox="0 0 30 30"
            >
              <circle style={{ fill: "#FFFFFF" }} cx="15" cy="15" r="15" />
              <polygon
                style={{ fill: "#969696" }}
                points="21.4,19.9 16.4,15 21.4,10.1 19.9,8.6 15,13.6 10.1,8.6 8.6,10.1 13.6,15 8.6,19.9 10.1,21.4 15,16.4 19.9,21.4 "
              />
            </svg>
          </span>
        </div>
        <div className="fiterlist-wrapper">
          <OverlayScrollbarsComponent className="overlay-scrollbar os-theme-dark">
            {filterList}
          </OverlayScrollbarsComponent>
        </div>
        {filterScreen && (
          <div className="filters-bottom-wrapper">
            <button
              type="button"
              onClick={resetFilters}
              className="reset-all-filters"
            >
              {t("reset")}
            </button>
            <button
              className="filter-to-map__btn"
              onClick={closeFilterScreen}
              style={{ display: showFiltersFrom === "from-map" ? "none" : "" }}
            >
              {t("search")} ({filteredEntities.length})
            </button>
            <button
              className="filter-to-map__btn"
              onClick={handleMapScreen}
              style={{ display: showFiltersFrom === "from-list" ? "none" : "" }}
            >
              {t("search")} ({filteredEntities.length})
            </button>
          </div>
        )}
      </div>
      <div
        className={`filter-overlay ${filterScreen ? "active" : ""}`}
        onClick={closeFilterScreen}
      ></div>

      {!mapScreen && !filterScreen && (
        <button className="sidebar-to-map__btn" onClick={handleMapScreen}>
          {t("displayMap")}
        </button>
      )}

      <Institution
        data={filteredEntities}
        selectedInstitution={selectedInstitution}
        setSelectedInstitution={setSelectedInstitution}
        client={process.env.REACT_APP_CLIENT}
        filters={data.filters}
        setMapScreen={setMapScreen}
        setScrollbarRef={setScrollbarRef}
        lineRefs={lineRefs}
        filtersKeys={filtersKeys}
      />
    </>
  );
};
export default FilterSection;
